import { render, staticRenderFns } from "./DocumentChip.vue?vue&type=template&id=3e498e4e&scoped=true&"
import script from "./DocumentChip.vue?vue&type=script&lang=js&"
export * from "./DocumentChip.vue?vue&type=script&lang=js&"
import style0 from "./DocumentChip.vue?vue&type=style&index=0&id=3e498e4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e498e4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/webapp-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VContainer,VFlex,VIcon,VLayout})
